/**
 * Canonical moon-avoidance defaults for the GUI (#1165).
 *
 * MOON_PEAK_DEFAULT is the separation required AT FULL MOON (the Lorentzian peak); MOON_WIDTH_DEFAULT
 * is the Lorentzian half-width at half-maximum, in days. Kept in sync with the server
 * (packages/server/src/config/moonDefaults.js) and the scheduler
 * (packages/python-scheduler/app.py). See #1165 for why a single value matters.
 */
export const MOON_PEAK_DEFAULT = 60;
export const MOON_WIDTH_DEFAULT = 5;
